import React, { useState, useEffect } from 'react';
import VisibilitySensor from 'react-visibility-sensor';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faBullseye, 
  faLayerGroup, 
  faChartLine, 
  faShieldAlt, 
  faUserFriends, 
  faHeadset
} from '@fortawesome/free-solid-svg-icons';
import 'animate.css';
import './About2.css';

const features = [
  {
    icon: faBullseye,
    title: 'Objective Driven',
    description: 'Our software range is meticulously designed to align with your goals & objectives, ensuring every feature serves your needs.'
  },
  {
    icon: faLayerGroup,
    title: 'Comprehensive',
    description: 'Our software offers a comprehensive solution, addressing every aspect of your requirements with no gaps in features.'
  },
  {
    icon: faChartLine,
    title: 'Scalable',
    description: 'The number of features can be adjusted based on the client\'s business size and budget to effectively meet diverse customer needs.'
  },
  {
    icon: faShieldAlt,
    title: 'Reliable',
    description: 'Trust is paramount, and our software consistently delivers reliable results, ensuring stability and consistency in every use case.'
  },
  {
    icon: faUserFriends,
    title: 'User Friendly',
    description: 'Designed with user-friendly interfaces and workflows, it prioritizes user-comfort, ensuring easy navigation and effective use.'
  },
  {
    icon: faHeadset,
    title: 'Customer Support',
    description: 'With responsive support, we\'re committed to assisting you at every step to ensure a satisfying experience.'
  }
];

function About2() {
    const [isVisible, setIsVisible] = useState(false);
    const [showAll, setShowAll] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth < 768);
        };
        
        checkMobile();
        window.addEventListener('resize', checkMobile);
        
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    const handleVisibilityChange = (visible) => {
        if (visible && !isVisible) {
            setIsVisible(true);
        }
    };

    const toggleShowAll = () => {
        setShowAll(!showAll);
    };

    // On mobile, show first 3, then rest if showAll is true
    // On desktop, show all
    const displayedFeatures = isMobile && !showAll ? features.slice(0, 3) : features;

    return (
        <section id="about" className="ptb-100 gray-light-bg operational-excellence-section">
            <div className="container">
                <div className="section-heading text-center mb-5">
                    <h2 className="web">Built for Operational Excellence</h2>
                    <p>We prioritize reliability, minimizing downtime and maximizing
                        productivity for healthcare providers nationwide. Our all software programs are:
                    </p>
                </div>
                
                <VisibilitySensor onChange={handleVisibilityChange} partialVisibility>
                    <div className="row">
                        {displayedFeatures.map((feature, index) => (
                            <div key={index} className="col-md-6 col-lg-4 mb-4">
                                <div 
                                    className={`feature-box-about2 ${isVisible ? 'animate__animated animate__slideInUp' : ''}`}
                                    style={{ animationDelay: `${index * 0.1}s` }}
                                >
                                    <div className="feature-box-header-about2">
                                        <FontAwesomeIcon icon={feature.icon} />
                                        <h5>{feature.title}</h5>
                                    </div>
                                    <div className="feature-box-body-about2">
                                        <p>{feature.description}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </VisibilitySensor>

                {/* View More Button - Only on Mobile */}
                {isMobile && (
                    <div className="text-center mt-4">
                        <button 
                            className="btn-view-all"
                            onClick={toggleShowAll}
                        >
                            {showAll ? 'View Less' : 'View More'}
                        </button>
                    </div>
                )}
            </div>
        </section>
    );
}

export default About2;
